<template>
  <div v-if="!redirecting">
    <h1>Error {{ error.statusCode }}</h1>
    <p>{{ error.message }}</p>
  </div>
</template>

<script setup>
const props = defineProps({ error: Object })
const router = useRouter()
const redirecting = ref(false)

onBeforeMount(() => {
  if (props.error?.statusCode === 404) {
    redirecting.value = true
    router.replace('/')
    // router.push('/')
  }
})
</script>





